import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
interface WhatToExpectSectionProps {
  checkoutUrl: string;
}
export const WhatToExpectSection = ({
  checkoutUrl
}: WhatToExpectSectionProps) => {
  const benefits = ['Comprenderás cómo funciona internamente el sistema crediticio en Estados Unidos y qué factores realmente influyen en tus aprobaciones.', 'Sabrás cómo estructurar correctamente tu compañía para acceder a funding ilimitado de bancos y lenders confiables.', 'Descubrirás cómo optimizar tu perfil crediticio para elevar tu score y calificar para mejores líneas de crédito.', 'Aprenderás a tomar decisiones financieras estratégicas que te permitan construir un perfil sólido y avanzar hacia tus metas con claridad.'];
  return <section className="w-full py-8 sm:py-12 px-4 bg-gray-50" data-id="element-228">
      <div className="container mx-auto max-w-4xl" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-8" data-id="element-230">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-3" data-id="element-231">
            Lo que puedes esperar después de la Masterclass
          </h2>
          <div className="h-1 w-20 bg-[#7A3EFF] mx-auto rounded-full" data-id="element-232" />
        </motion.div>
        <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8" data-id="element-233">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-3 bg-white p-4 sm:p-5 rounded-xl border-2 border-[#7A3EFF] shadow-sm" data-id="element-234">
              <CheckCircleIcon size={24} className="text-[#7A3EFF] flex-shrink-0 mt-0.5" data-id="element-235" />
              <p className="text-gray-800 text-sm sm:text-base leading-relaxed" data-id="element-236">
                {benefit}
              </p>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex justify-center" data-id="element-237">
          <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="inline-block px-10 sm:px-14 py-4 bg-white text-[#7B2BFD] text-lg sm:text-xl font-bold rounded-full transition-all duration-300" style={{
          border: '3px solid #7B2BFD',
          boxShadow: '0 0 20px rgba(123, 43, 253, 0.4), 0 0 40px rgba(123, 43, 253, 0.2)'
        }} animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.08,
          boxShadow: '0 0 30px rgba(123, 43, 253, 0.6), 0 0 60px rgba(123, 43, 253, 0.4)'
        }} whileTap={{
          scale: 0.95
        }} data-id="element-238">
            RESERVAR MI CUPO
          </motion.a>
        </motion.div>
      </div>
    </section>;
};